import { SubmissionError } from "redux-form";
import showToaster from "../../../helpers/showToaster";
import messages from "../../../locale/messages";
import updateConfigSettings from "../../../actions/siteadmin/SiteSettings/updateConfigSettings";

import {
  inputTextLimit,
  containsMalicious,
  containsMaliciousForEditor,
} from "../../../helpers/textRestriction";

async function submit(values, dispatch) {
  // Fields to validate for XSS and length
  const fieldsToValidate = [
    "fcmPushNotificationKey",
    "deepLinkBundleId",
    "stripePublishableKey",
    "maxUploadSize",
    "smtpHost",
    "smtpPort",
    "smptEmail",
    "smtpSender",
    "smtpSenderEmail",
    "smtpPassWord",
    "twillioAccountSid",
    "twillioAuthToken",
    "twillioPhone",
    "paypalClientId",
    "paypalSecret",
    "paypalHost",
    "googleClientId",
    "googleSecretId",
  ];

  // Validate normal text fields
  for (const field of fieldsToValidate) {
    const value = values[field];
    if (value) {
      if (containsMalicious(value)) {
        showToaster({ messageId: "invalidInput", toasterType: "error" });
        throw new SubmissionError({
          _error: `${field}: ${messages.invalidInput}`,
        });
      }

      if (value.length > inputTextLimit) {
        showToaster({ messageId: "invalidInput", toasterType: "error" });
        throw new SubmissionError({
          _error: `${field}: ${messages.inputTooLong}`,
        });
      }
    }
  }

  // Special check for deepLinkContent (textarea)
  if (values.deepLinkContent) {
    if (containsMaliciousForEditor(values.deepLinkContent)) {
      showToaster({ messageId: "invalidInput", toasterType: "error" });
      throw new SubmissionError({
        _error: `deepLinkContent: ${messages.invalidInput}`,
      });
    }

    if (values.deepLinkContent.length > inputTextLimit) {
      showToaster({ messageId: "invalidInput", toasterType: "error" });
      throw new SubmissionError({
        _error: `deepLinkContent: ${messages.inputTooLong}`,
      });
    }
  }

  // Submit only if all validations pass
  await dispatch(updateConfigSettings(values));
}

export default submit;
